import Title from '#/components/common/toast/Title';
import Error from '#/components/common/toast/Error';

export function AccountIsBeingLiquidated() {
  return (
    <Error>
      <Title>Account in liquidation</Title>
      Account is being liquidated. Any open positions will be closed. Trading
      now is disabled.
    </Error>
  );
}
